<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-08-06 15:28:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div class="continueSuccess-wrap"
   v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="continueSuccess-back"></div>
    <div class="continueSuccess-top">
      <div class="continueSuccess-box">
        <div style="color: #007B83;"><span style="width: 0.14rem;display:inline-block"></span> 在线续停业务办理成功</div>
        <div class="agreement-check" >
          <div v-if="checked" @click="checked = false" style="margin-right: 5px">
            <img
              src="../../../assets/image/selected-icon.png"
              style="width: 0.16rem;height:0.16rem;margin-top:0.03rem"
              alt
            />
            <span style="margin-left: 0.1rem;">继续办理房屋跑漏险</span>
          </div>
          <div v-else @click="checked = true" style="margin-right: 5px">
            <img
              src="../../../assets/image/outcheck-icon.png"
              alt
              style="width: 0.16rem;height:0.16rem;margin-top:0.03rem"
            />
            <span style="margin-left: 0.1rem;">继续办理房屋跑漏险</span>
          </div>
        </div>
      </div>
    </div>
    <div class="continueSuccess-bottom">
      <el-button type="primary" style="background:#007B83;color:#fff;border:none;width:2.7rem;padding:4%" @click="goHome">确认</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      continueStopSuccess: '',// 在线续停成功
      checked: true, // 是否继续办理房屋跑漏险
      loading:false,
      loadingText:'', // loading信息
      cardCode:'',// 供热卡号
      userName:'',// 用户姓名
    }
  },

  methods:{
    // 查询是否绑定了房屋信息
    async getBindingStatus(){
      const res = await this.$http.get(`${this.$url.globalurl}/wxUser/0`);
      if(res.result.length){
        this.cardCode = res.result[0].heating_card_num;
        const hourRes = await this.$http.get(`${this.$url.globalurl}/wxHouseInfo`);
        this.userName = hourRes.result.owner_name;
      }
    },
    // 查询跑漏险缴费资格
    async getInsuranceInfo(){
      this.loading = true;
      this.loadingText = '正在查询您的缴费资格，请稍等';
      this.getBindingStatus()
      const res = await this.$http.get(this.$url.globalurl + '/wxPayMent/0',{
        data:{
          risk:true
        }
      });
      if(res.code === 200){
        if(res.result.can_paid){
          this.loading = false;
          // 跑漏险跳转
          this.$router.replace({
            name:'insurance',
            query:{
              cardCode:this.cardCode,
              phone:this.phone,
              payFlag:false,
              userName:this.userName
            }
          })
        }else{
          this.loading = false;
          // 没有交费资格
          this.$router.replace({
            name:'searchHint',
            query:{
              payFlag:false,
              payTime:res.result.time
            }
          })
        }
      }
    },
    goHome(){
      if(this.checked == false) {
        this.$router.replace({
          name:'index'
        })
      }else {
        this.getInsuranceInfo()
      }
    },
  },

  mounted(){
    document.title = "办理结果";
  }
}
</script>
<style lang='scss' scoped>
.continueSuccess-wrap{
  width: 100vw;
  height: 100vh;
}
.continueSuccess-back{
  position: absolute;
  width: 100%;
  height: 0px;
  top: 0;
  padding-bottom: 25%;
  background-image: url(../../../assets/image/bgtop.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.continueSuccess-top{
  width: calc(100% - 40px);
  position: absolute;
  background: #ffffff;
  padding: 5px 10px;
  border: solid 1px none;
  border-radius: 10px;
  margin: 0px 20px;
  top: 3%;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.15);;
}
.continueSuccess-box{
  padding: 0.4rem 0.15rem 0.3rem 0.15rem;
  color: #333333;
  opacity: 0.8;
  line-height: 0.25rem;
}
.continueSuccess-bottom{
  width: 100%;
  text-align: center;
  position: absolute;
  top: 2.9rem;
}
.continueSuccess-box > div span{
  vertical-align: middle;
}
.agreement-check{
  display: flex;
  margin-top: 0.1rem;
  line-height: 0.2rem;
}
.agreement-check > div{
  display: flex;
  height: 0.2rem;
  vertical-align: middle;
}
</style>
